export default __webpack_public_path__ + "static/og-hackathon-5-69d32ff65e480990eaf41b05500c20a4.jpg";